import { Paper, PaperProps, styled } from "@mui/material";
import React from "react";
import { pxToRem } from "../../../utils/fontSizeUtility";
import { breakpointValues, customBreakpoints } from "../../../styles/breakpoints";

export const MistPaper = styled(Paper)<PaperProps>(({ theme }) => ({
  height: 0,
  left: 0,
  position: "absolute",
  zIndex: "0",
  width: "100%",
  [customBreakpoints.up(breakpointValues.md)]: {
    background: `linear-gradient(180deg, ${theme.palette.background.default} 0.05%, rgba(255,255,255,0) 100%)`,
    height: pxToRem(44),
    width: "100%",
    pointerEvents: "none",
  },
})) as React.ComponentType<PaperProps>;
